import { ILogEventParams } from '@/utils/bridgeUtils/features/sendLogEvent'

import { call } from '../core'


export function sendMoeLogEvent(params: ILogEventParams) {
  call('finMoEngageLogEvent', params)
}
